import { paths } from 'src/routes/paths';

/**
 * Maps notification types/actions to in-app navigation routes
 */

const ROUTE_MAP: Record<string, string> = {
  // Transaction notifications
  transaction_approved: paths.dashboard.artham.history,
  transaction_rejected: paths.dashboard.artham.history,
  transaction_success: paths.dashboard.artham.history,
  transaction_failed: paths.dashboard.artham.history,
  transaction_approval_required: paths.dashboard.artham.history,
  info_requested: paths.dashboard.artham.history,

  // Credit notifications
  credit_approved: paths.dashboard.root,
  credit_rejected: paths.dashboard.root,
  credit_low: paths.dashboard.root,
  credit_extension_request: paths.dashboard.root,

  // Collection notifications
  cash_reminder: paths.dashboard.artham.collection,
  cash_overdue: paths.dashboard.artham.collection,

  // KYC notifications
  kyc_pending: paths.dashboard.root,
  kyc_approved: paths.dashboard.root,
};

/**
 * Get navigation path from notification data
 */
export function getNavigationPath(data: Record<string, string>): string | null {
  const type = data?.type || data?.action;
  if (!type) return null;
  return ROUTE_MAP[type] || paths.dashboard.root;
}

/**
 * Handle notification tap - navigate to the appropriate screen
 */
export function handleNotificationTap(notification: any, navigate: (path: string) => void): void {
  const data = notification?.notification?.data || notification?.data || {};

  const path = getNavigationPath(data);
  if (path) {
    navigate(path);
  }
}
